module.exports = __webpack_public_path__ + "img/img-report-sample.ecd886cc.png";